module.exports = __webpack_public_path__ + "static/media/img_frame.58b975bd.webp";